export enum EContentEvents {
  clickedCtaButton = 'user_clicked_cta_button',
  visitedSection = 'user_visited_section',
}
